import request from '@/utils/request'


// 查询兴趣标签列表
export function listCommunityInterestTag(query) {
  return request({
    url: '/biz/admin/community/community/interest/tag/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询兴趣标签分页
export function pageCommunityInterestTag(query) {
  return request({
    url: '/biz/admin/community/community/interest/tag/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询兴趣标签详细
export function getCommunityInterestTag(data) {
  return request({
    url: '/biz/admin/community/community/interest/tag/detail',
    method: 'get',
    params: data
  })
}

// 新增兴趣标签
export function addCommunityInterestTag(data) {
  return request({
    url: '/biz/admin/community/community/interest/tag/add',
    method: 'post',
    data: data
  })
}

// 修改兴趣标签
export function updateCommunityInterestTag(data) {
  return request({
    url: '/biz/admin/community/community/interest/tag/edit',
    method: 'post',
    data: data
  })
}

// 删除兴趣标签
export function delCommunityInterestTag(data) {
  return request({
    url: '/biz/admin/community/community/interest/tag/delete',
    method: 'post',
    data: data
  })
}